(function () {
  const defaults = {
    selector: '[data-animate], .fadein, .slidein, .image-typing-effect, .popup', // 対象セレクタ
    root: null,
    rootMargin: '0px 0px -10% 0px', // 要素が少し見えたら発火
    threshold: 0.03, // 3% 見えたら発火
    defaultDelay: 300, // 見えてから何ms後にクラスを付ける
    once: true // 一度付けたら再度は付けない
  };

  const opts = Object.assign({}, defaults);

  // IntersectionObserver callback
  function onIntersect(entries, observer) {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      const el = entry.target;

      // 要素固有の遅延（ms）を data-animate-delay 属性で上書き可能
      const attrDelay = el.getAttribute('data-animate-delay');
      const delay = attrDelay !== null ? parseInt(attrDelay, 10) || 0 : opts.defaultDelay;

      // タイムアウトでクラスを付与
      const timerId = setTimeout(() => {
        el.classList.add('is-animated');

        // 付けたあとに再発火させたくなければ observer.unobserve
        if (opts.once) {
          observer.unobserve(el);
        }
      }, delay);

      // 要素が見えなくなってタイムアウトをキャンセルしたい場合はここで処理できる。
      // （今回は一度見えたら付与する設計なのでキャンセル処理はしない）
      // el._animateTimer = timerId;
    });
  }

  // 初期化
  function init() {
    const nodes = document.querySelectorAll(opts.selector);
    if (!nodes.length) return;

    // IntersectionObserver サポートの有無で分岐
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(onIntersect, {
        root: opts.root,
        rootMargin: opts.rootMargin,
        threshold: opts.threshold
      });

      nodes.forEach(n => observer.observe(n));
    } else {
      // フォールバック: 単純に遅延で全要素に付与（ポリフィル無し）
      nodes.forEach(n => {
        const attrDelay = n.getAttribute('data-animate-delay');
        const delay = attrDelay !== null ? parseInt(attrDelay, 10) || 0 : opts.defaultDelay;
        setTimeout(() => n.classList.add('is-animated'), delay);
      });
    }
  }

  // DOMContentLoaded または遅延ロード対応
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // 必要なら外部からオプションを上書きできるようにする
  window.AddAnimatedOnVisible = {
    configure: function (custom) {
      Object.assign(opts, custom || {});
    }
  };
})();
